import { api } from "../../services";
import { $config } from "../../conf";
import $store from "../../store";

export let articleAPI = {
  /**
   * 获取某个栏目下的栏目列表,包含子级栏目
   * @param articleCategoryId 栏目id
   * @param moduleId
   * @param instanceId
   * @param isEnabled 是否前台可见(1是 0否)
   * @param isRefresh
   * @param isStatic
   * @returns {Promise<any>}
   */
  onArticleCategorySubQuery({
    articleCategoryId,
    moduleId = 0,
    instanceId = 0,
    isEnabled = 1,
    isRefresh,
    isStatic = $config.isStatic,
  }) {
    return $store.dispatch("statics/onSync", {
      apiPath: "/api/article/category/sub/query",
      tenantId: $config.tenantId,
      articleCategoryId,
      moduleId,
      instanceId,
      isEnabled,
      isRefresh,
      isStatic,
    });
  },

  /**
   * 获取文章列表
   * @param instanceId 实例id
   * @param articleIds 文章ids
   * @param typeIds 分类ids
   * @param articleCategoryId 文章所属栏目ids
   * @param title 文章标题
   * @param summary 文章摘要
   * @param isRecommend 是否推荐(-1全部 0不推荐 1推荐)
   * @param hasChildrenCategory 文章分类是否包含子栏目(1是 0否)
   * @param isTop 是否置顶(-1全部 0不置顶 1置顶)
   * @param isWithStat 是否需要点赞、分享、浏览统计(1是 0否)
   * @param sort 排序方式，默认按创建时间倒序排序(1创建时间正序 2创建时间倒序 3最后更新时间正序 4最后更新时间倒序 5排序字段正序 6排序字段倒序)
   * @param tags 标签ids(支持标签属性之间的并且、或；并且格式：[{tagId0:["吃饭"]},{tagId1:["打豆豆"]}]；或格式：[{tagId0:["打豆豆"],tagId1:["打豆豆"]}])
   * @param start
   * @param num
   * @param isRefresh
   * @param isStatic
   * @returns {*}
   */
  onArticleQuery({
    instanceId = 0,
    articleIds,
    typeIds,
    articleCategoryId,
    title,
    summary,
    isRecommend = -1,
    hasChildrenCategory = 1,
    isTop = -1,
    isWithStat = 1,
    sort = [6, 4],
    tags,
    start = 0,
    num = 50,
    isRefresh,
    isStatic = $config.isStatic,
  }) {
    return $store.dispatch("statics/onSync", {
      apiPath: "/api/article/query",
      tenantId: $config.tenantId,
      instanceId,
      articleIds,
      typeIds,
      articleCategoryId,
      title,
      summary,
      isRecommend,
      hasChildrenCategory,
      isTop,
      isWithStat,
      sort,
      tags,
      start,
      num,
      isRefresh,
      isStatic,
    });
  },

  /**
   * 获取文章详情信息
   * @param articleId 文章id
   * @param isWithStat 是否需要点赞、分享、浏览统计(1是 0否)
   * @param isScroll 是否需要查询上一篇和下一篇文章id(1是 0否)
   * @param isWithTag 是否需要标签(1是 0否)
   * @param isRefresh
   * @param isStatic
   * @returns {Promise<any>}
   */
  onArticleGet({
    articleId,
    isWithStat = 1,
    isScroll = 0,
    isWithTag = 1,
    isRefresh,
    isStatic = $config.isStatic,
  }) {
    return $store.dispatch("statics/onSync", {
      apiPath: "/api/article/get",
      tenantId: $config.tenantId,
      articleId,
      globalUserId: $store.state.userInfo.globalUserId,
      sess: $store.state.userInfo.session,
      openId: $store.state.userInfo.openId,
      isWithStat,
      isScroll,
      isWithTag,
      isRefresh,
      isStatic,
    });
  },
  /**
   * 获取当前用户的收藏列表
   * @param start
   * @param num
   * @returns {*}
   */
  onArticleGetCollectionList({ start, num }) {
    return api
      .request("/article/getCollectionList", {
        start,
        num,
        sess: $store.state.userInfo.session,
      })
      .catch((data) => {
        // 暂无收藏数据
        if (data.result == "268451864") {
          return {
            content: [],
            desc: "successful",
            result: 0,
          };
        }
      });
  },
  onArticleBrowse({ articleId, pageTitle, browseInfo }) {
    return api.request("/article/browse", {
      articleId,
      pageTitle,
      browseInfo,
      url: window.location.href,
      referenceUrl: document.referrer,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
    });
  },
  onArticleLike({ articleId }) {
    return api.request("/article/like", {
      articleId,
      url: window.location.href,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
    });
  },
  onArticleCollect({ articleId, status }) {
    return api.request("/article/Collection", {
      articleId,
      status,
      url: window.location.href,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
    });
  },

  getLikeStatus({ articleId }) {
    return api.request("/api/article/like/check", {
      articleId,
      url: window.location.href,
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
    });
  },
  getCollectStatus({ articleId }) {
    return api.request("/api/article/collection/check", {
      articleId,
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
    });
  },
  getCommentList({ topicId, subVersionId }) {
    return api.request("/comment/getList", {
      topicId,
      subVersionId,
      commentId: 0,
      start: 0,
      num: 50,
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
      cookieId: $store.state.userInfo.globalUserId,
    });
  },
  createComment({ topicId, subVersionId, content, title }) {
    return api.request("/comment/create", {
      title,
      content,
      topicId,
      subVersionId,
      commentId: 0,
      instanceId: "0",
      isAnonymous: 0,
      moduleId: "0",
      tenantId: $config.tenantId,
      nodeId: $config.tenantId,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
      cookieId: $store.state.userInfo.globalUserId,
    });
  },
  deleteComment({ topicId, commentId }) {
    return api.request("/comment/front/delete", {
      topicId,
      commentId,
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
      cookieId: $store.state.userInfo.globalUserId,
    });
  },
  likeComment({ commentIds }) {
    return api.request("/comment/like", {
      commentIds,
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
      globalUserId: $store.state.userInfo.globalUserId,
      cookieId: $store.state.userInfo.globalUserId,
    });
  },
};
